// Nombre de un regalo en una venta cerrada (slot `giftName`): el de su línea o, si es el SKU,
// el de Promociones (tienda) o el del catálogo de la cadena (Admin VL).
import type { SaleAudience } from '../lib/saleAudience';
import { sessionIdOfSale } from '../lib/saleClosing';
import { CatalogGiftName } from './CatalogGiftName';
import { SummaryGiftName } from './SummaryGiftName';

export interface ClosedSaleGiftNameProps {
    saleId: string;
    audience: SaleAudience;
    sku: string;
    /** Nombre que trae la línea vendida; es el SKU cuando no lo conoce. */
    lineName: string;
    /** Cadena de la venta; con ella el Admin VL lee el nombre del catálogo. */
    retailerId?: string;
}

/** Solo la tienda evalúa la sesión de la venta; el Admin VL lee el producto del catálogo. */
export function ClosedSaleGiftName({
    saleId,
    audience,
    sku,
    lineName,
    retailerId,
}: ClosedSaleGiftNameProps) {
    if (lineName !== sku) return <>{lineName}</>;
    if (audience !== 'STORE') {
        return retailerId ? (
            <CatalogGiftName retailerId={retailerId} sku={sku} lineName={lineName} />
        ) : (
            <>{lineName}</>
        );
    }
    return <SummaryGiftName sessionId={sessionIdOfSale(saleId)} sku={sku} catalogName={lineName} />;
}
